import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Actividad reciente',
  actions: {
    clicked: 'Clicado',
    open: 'Abierto',
    scheduled: 'Programado',
    sent: 'Enviado',
  },
  fields: {
    recipients: '{{recipients}} destinatarios',
    opened: '{{rate}} abiertos',
    clicked: '{{rate}} clicados',
    awaiting: 'Pendiente de confirmación',
  },
  template_types: TemplateNames,
};
